export class ConceptContactModel {
    uid : string;
    ownerUid : string;
    concept : string;
    conceptUid : string;
    contact : string;
    contactUid : string;
    conceptCode : string;
    price : number;
}